<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Добавление файла') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">

        <v-row>
          <v-col>
            <ValidationObserver ref="page">
              <ValidationProvider v-slot="{ errors }" :name="`'${$t('Тип загружаемого файла')}'`" rules="required" vid="staticFileTyped">
                <v-row
                    class="grey lighten-2 rounded mt-2"
                    rounded>
                  <v-col cols="12">
                    <v-overflow-btn
                        v-model="staticFileType"
                        :items="staticFileTypes"
                        item-value="type"
                        item-text="description"
                        return-object
                        solo
                        dense
                        :error-messages="errors"
                        :label="$t('Выберите тип загружаемого файла')"
                        hide-details>
                      <template v-slot:append-outer>
                        <static-file-input
                            v-if="staticFileType"
                            icon="attach_file"
                            @change="fileSelected" />
                      </template>
                    </v-overflow-btn>
                  </v-col>
                </v-row>
              </ValidationProvider>
            </ValidationObserver>
          </v-col>
        </v-row>
        <v-row v-if="file">
          <text-view
              v-if="fileName"
              :display="fileName"
              :label="$t('Наименование файла')" />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import StaticFileInput from '@/components/reused/ui/StaticFileInput.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions } from 'vuex'
  import { STATIC_PAGES } from '@/constants/store.js'
  import { STATIC_FILE_TYPE_ENUM } from '@/constants/enums'

  export default {
    components: {
      TextView,
      GeneralError,
      StaticFileInput
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        staticFileType: null,
        fileName: null,
        file: null
      }
    },
    computed: {
      staticFileTypes () {
        return Object.keys(STATIC_FILE_TYPE_ENUM).map(key => {
          return {
            type: key,
            description: this.$t(STATIC_FILE_TYPE_ENUM[key])
          }
        })
      }
    },
    watch: {
      'staticFileType.type': {
        deep: true,
        handler (newVal, oldVal) {
          if (newVal !== oldVal) {
            this.file = null
            this.fileName = null
          }
        }
      }
    },
    created () {

    },
    methods: {
      ...mapActions(STATIC_PAGES.NAMESPACE, {
        uploadStaticFileAction: STATIC_PAGES.ACTIONS.UPLOAD_STATIC_FILE,
        editStaticFileAction: STATIC_PAGES.ACTIONS.EDIT_STATIC_FILE
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearFullPageInfoAction()
          ])
      },
      fileSelected: function (file) {
        const form = new FormData()
        // form.append('path', this.path)
        form.append('staticFileType', this.staticFileType.type)
        form.append('file', file.file, file.name)
        this.file = form
        this.fileName = file.name
      },
      uploadStaticFile: async function (file) {
        await this.uploadStaticFileAction(file)
      },
      continueOperation: async function () {
        const result = await this.$refs.page.validate()
        if (!result) {
          return
        }
        if (!this.file) {
          throw new Vue.errorsTypes.ValidationError(this.$t('Файл не выбран'))
        }
        try {
          this.isLoading = true

          await this.uploadStaticFile(this.file)

          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
